/**
 * @typedef {import("react").HTMLAttributes<SVGElement>} IProps
 * */
/**
 * @returns {JSX.Element} Квадратная иконка ВКонтакте
 * @param {IProps} props
 * */
export default function VkIcon({ ...etc }) {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" xmlns="http://www.w3.org/2000/svg" {...etc}>
      <g clipPath="url(#clip0_6211_423516)">
        <path
          d="M0 11.0576C0 6.07951 0 3.59051 1.54648 2.04403C3.09295 0.497559 5.58195 0.497559 10.56 0.497559H11.44C16.4181 0.497559 18.907 0.497559 20.4535 2.04403C22 3.59051 22 6.07951 22 11.0576V11.9376C22 16.9156 22 19.4046 20.4535 20.9511C18.907 22.4976 16.4181 22.4976 11.44 22.4976H10.56C5.58195 22.4976 3.09295 22.4976 1.54648 20.9511C0 19.4046 0 16.9156 0 11.9376V11.0576Z"
          fill="#0077FF"
        />
        <path
          d="M11.7057 16.347C6.69152 16.347 3.83157 12.9095 3.7124 7.18945H6.22407C6.30657 11.3878 8.15819 13.1661 9.62486 13.5328V7.18945H11.9899V10.8103C13.4383 10.6545 14.9598 9.00445 15.4731 7.18945H17.8381C17.444 9.42612 15.794 11.0761 14.6206 11.7545C15.794 12.3045 17.6732 13.7436 18.3882 16.347H15.7848C15.2256 14.6053 13.8324 13.2578 11.9899 13.0745V16.347H11.7057Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6211_423516">
          <rect width="22" height="22" fill="white" transform="translate(0 0.497559)" />
        </clipPath>
      </defs>
    </svg>
  );
}
